<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form class="multi-col-validation">
      <v-card-text>
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiCheckDecagram }}
          </v-icon>
          <span>Redes Sociais</span>
        </v-card-title>

        <v-row class="mt-3">
          <v-col
            md="6 "
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.facebook"
              label="Facebook"
              dense
              outlined
              :rules="[validators.urlValidator]"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.instagram"
              label="Instagram"
              dense
              outlined
              :rules="[validators.urlValidator]"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.telegram"
              label="Telegram"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.twitter"
              label="Twitter"
              dense
              outlined
              :rules="[validators.urlValidator]"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.linkedIn"
              label="LinkedIn"
              dense
              outlined
              :rules="[validators.urlValidator]"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.redesSociais.outro"
              label="Outro"
              dense
              outlined
              :rules="[validators.urlValidator]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          @click="update"
        >
          Salvar alterações
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          disabled
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mb-2 mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
import {
  alphaValidator, emailValidator, passwordValidator, required, urlValidator,
} from '@core/utils/validation'
import {
  mdiCheckDecagram, mdiAccountOutline, mdiCloudOutline, mdiHelpCircleOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    socialsData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  // data() {
  //   return {
  //   }
  // },

  beforeMount() {
    if (!this.accountDataLocale.redesSociais) {
      this.accountDataLocale.redesSociais = {
        facebook: '',
        instagram: '',
        telegram: '',
        twitter: '',
        linkedIn: '',
        outro: '',
      }
    }
  },
  methods: {
    update() {
      // console.log(JSON.stringify(this.accountDataLocale))
      this.accountDataLocale.id = null
      ColaboradorService
        .update(this.accountDataLocale)
    },
  },
  setup(props) {
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.socialsData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.socialsData))
    }

    return {
      accountDataLocale,
      resetForm,
      icons: {
        mdiCheckDecagram,
        mdiAccountOutline,
        mdiCloudOutline,
        mdiHelpCircleOutline,
      },
      validators: {
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
        urlValidator,
      },
    }
  },
}
</script>
